import { useSelector, useDispatch } from 'react-redux';
import { cloneDeep, find, findIndex, isEmpty } from 'lodash';
import { ERROR_STATUSES, Screens } from '../../constants/Activation/enum';
import { postAccountActivation } from '../../api/Activation/postAccountActivation';
import { useTranslation } from 'react-i18next';
import { setActivationFailureErrorMsg } from '../../store/slices/Activation/activationSlice';
import { getCSRFToken } from '../../api/csrfToken';
import { setFormData } from '../../store/slices/Activation/formSlice';

/**
 * Hook to call the api toactivate the user account and set the state
 * @Hook
 * @param   {function} setScreen  useState function to set the screen to be displayed
 * @param   {function} setLoading useState function to set the loader
 * @return  {function}            postActivateAccount function
 */
const usePostActivateAccount = (setScreen, setLoading) =>
{
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { form, readOnlyFields } = useSelector((state) => state.form)

  /**
   * call postAccountActivation api function and use the response to set the validation error for failures or display the success screen
   * @param   {string} activationToken  Activation Token
   * @param   {string} activationId Activation ID
   * @param   {string} productId Product ID
   */
  const postActivateAccount = async ({ activationToken, activationId, productId }) =>
  {
    try
    {
      setLoading(true)
      const firstNameValue = find(form, { field: "firstName" })?.value
      const lastNameValue = find(form, { field: "lastName" })?.value
      const email = find(readOnlyFields, { label: "email" })?.value || "";
      const payload = {
        activationToken,
        activationId,
        productId,
        userEmail: email,
        firstName: isEmpty(firstNameValue?.trim()) ? "FNU" : firstNameValue,
        lastName: isEmpty(lastNameValue?.trim()) ? "LNU" : lastNameValue,
        password: find(form, { field: "password" }).value,
        phoneNumber: find(form, { field: "phoneNumber" }).value,
        userPreferredLanguage: find(form, { field: "language" }).value?.value || ""
      }
      const token = await getCSRFToken("Post-Activation")
      const response = await postAccountActivation(payload, token.data.csrfToken)
      console.log(response)
      if (response.status === 200)
      {
        setLoading(false)
        setScreen(Screens.SUCCESS)
      }
    }
    catch (err)
    {
      setLoading(false)
      if (window.location.host === "localhost:3000")
      {
        setScreen(Screens.SUCCESS)
      }
      else
      {
        console.log(err)
        if (err.response.data?.error?.status === ERROR_STATUSES.INVALID_TOKEN)
        {
          dispatch(setActivationFailureErrorMsg(t('activationErrorScreen.invalidInvitation')))
          setScreen(Screens.ACTIVATION_FAILURE)
        }
        else if (err.response.data?.error?.status === ERROR_STATUSES.VALIDATION_FAILED)
        {
          let formData = cloneDeep(form)
          let passwordIndex = findIndex(formData, { field: "password" })
          let phoneNumberIndex = findIndex(formData, { field: "phoneNumber" })
          let validationError = err.response.data.error.inputValidations
          if (!validationError.newPassword.valid)
          {
            formData[passwordIndex].error = true
            formData[passwordIndex].errorMessage = t('widget.password.invalidPasswordMessage')
          }
          if (!validationError.phoneNumber.valid)
          {
            formData[phoneNumberIndex].error = true
            formData[phoneNumberIndex].errorMessage = t('widget.phoneNumber.invalidNumberMessage')
          }
          dispatch(setFormData(formData))
        }
        else
        {
          setScreen(Screens.FALLBACK_ERROR)
        }
      }
    }
  }
  return [postActivateAccount]
}
export default usePostActivateAccount;